import { render, staticRenderFns } from "./AgentNovelListItem.vue?vue&type=template&id=23bfa40c&scoped=true"
import script from "./AgentNovelListItem.vue?vue&type=script&lang=ts"
export * from "./AgentNovelListItem.vue?vue&type=script&lang=ts"
import style0 from "./AgentNovelListItem.vue?vue&type=style&index=0&id=23bfa40c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bfa40c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23bfa40c')) {
      api.createRecord('23bfa40c', component.options)
    } else {
      api.reload('23bfa40c', component.options)
    }
    module.hot.accept("./AgentNovelListItem.vue?vue&type=template&id=23bfa40c&scoped=true", function () {
      api.rerender('23bfa40c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/AgentNovelListItem.vue"
export default component.exports